import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import type { Constructor } from '@whispli/types';

export class __UserAbility extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly name!: string;
  /**
   * @deprecated For backwards-compatibility only. Use entityType
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private entity_type!: string | null;

  @Expose({groups: ['client']})
  public get entityType() {
    return this.entity_type
  }

  public set entityType(value) {
    this.entity_type = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use entityId
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private entity_id!: string | null;

  @Expose({groups: ['client']})
  public get entityId() {
    return this.entity_id
  }

  public set entityId(value) {
    this.entity_id = value
  }
}
export type UserAbility = Omit<__UserAbility, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'entity_type' | 'entity_id'>
export const UserAbility = __UserAbility as any as Constructor<UserAbility>
